import React from 'react'
import { Page } from './SettingsStyle'

export default function Pages({ handleAbove }: any) {
  const pages = [
    { title: 'Provably Fair', above: 'Provably Fair' },
    {
      title: 'History',
      above: 'History',
    },
    {
      title: 'Game Rules',
      above: 'Game Rules',
    },
    // {
    //   title: 'Free BTC Faucet',
    //   above: 'FreeBTC',
    // },
  ]
  return (
    <>
      {pages.map((page: any, id: number) => (
        <Page key={id} onClick={() => handleAbove(page.above)}>
          {page.title}
        </Page>
      ))}
    </>
  )
}
